module.exports = __webpack_public_path__ + "static/media/SDFSA_2-682w.34937f96.webp";